export const CHART_PADDING = 20;
export const CHART_PADDING_RIGHT = 40;
export const CHART_PADDING_BOTTOM = 42;

export const CHART_HEIGHT = 200;
